// Components
import { CustomGridTreeDataGroupAllHeader } from "@Layouts/components/TreeGrid/CustomGridTreeDataGroupAllHeader";
// Types and constants
import { GridGroupingColDefOverride } from "@mui/x-data-grid-pro";
import { CustomGridTreeDataGroupAllHeaderProps } from "@Layouts/components/types";
import { prepareGroupColDef } from "@/Layouts/components/TreeGrid/prepareGroupColDef";
import { DataGridPremiumProps } from "@mui/x-data-grid-premium";

export function getGroupColumnDefinition(topAligned: boolean, apiRef?: DataGridPremiumProps["apiRef"]): GridGroupingColDefOverride {
	return {
		...prepareGroupColDef(),
		renderHeader: (params) => (
			<CustomGridTreeDataGroupAllHeader topAligned={topAligned} apiRef={apiRef} {...(params as CustomGridTreeDataGroupAllHeaderProps)} />
		),
	};
}
